export const countryMap = {
    'ba': 'Bosnia',
    'rs': 'Serbia',
    'hr': 'Croatia',
    'me': 'Montenegro',
    'mk': 'Macedonia'
};